import Banner from './Banner';
export { Banner as default };
